export class ValidationError extends Error {
    readonly kind = 'ValidationError';
    constructor(public errorBag: Record<string, string[]>) {
        super('ValidationError');
    }
}
